var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-item"},[_c('div',{staticClass:"data-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-body"},[(_vm.data === null || _vm.data === undefined)?_c('div',[_vm._v("N/A")]):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }